<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>{{ boxTitle }}</b>
						</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-8">
								<div class="form-group">
									<label>Nome</label>
									<input v-validate="'required'" name="nome" v-model="dados.nome" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('nome') }}</span>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Conselho</label>
									<select v-validate="'required'" name="conselho" v-model="dados.conselho" class="form-control">
												<option value="CRM">CRM</option>
												<option value="CREFITO">CREFITO</option>
												<option value="CRO">CRO</option>
												<option value="CRN">CRN</option>
												<option value="CRP">CRP</option>
												<option value="CRFA">CRFA</option>
												<option value="OUTRO">OUTRO</option>
											</select>
									<span class="text-danger">{{ errors.first('conselho') }}</span>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Nº Registro Conselho</label>
									<input v-validate="'required'" name="registro_conselho" v-model="dados.registro_conselho" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('registro_conselho') }}</span>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>CNS</label>
									<input name="cns" v-model="dados.cns" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('cns') }}</span>
								</div>
							</div>

							<div class="col-md-6">
								<div class="form-group">
									<label>E-mail</label>
									<input style="text-transform: none !important" name="email" v-model="dados.email" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('email') }}</span>
								</div>
							</div>

							<div class="col-md-3">
								<div class="form-group">
									<label>Telefone</label>
									<input v-mask="['(##)#####-####', '(##)####-####']" v-model="dados.telefone" class="form-control" type="text">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>Sexo</label>
									<select v-model="dados.sexo" class="form-control">
			                    <option :value="SEXO.MASCULINO">Masculino</option>
			                    <option :value="SEXO.FEMININO">Feminino</option>
			                  </select>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Data de Nascimento</label>
									<input v-model="dados.data_nascimento" class="form-control" type="date">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Data de admissão</label>
									<input v-model="dados.data_admissao" class="form-control" type="date">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Data de desligamento</label>
									<input v-model="dados.data_desligamento" class="form-control" type="date">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-2">
								<div class="form-group">
									<label>CPF</label>
									<input name="cpf" v-mask="'###.###.###-##'" v-model="dados.cpf" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('cpf') }}</span>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>RG</label>
									<input v-mask="'##########'" v-model="dados.rg" class="form-control" type="text">
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Orgão emissor do RG</label>
									<input v-model="dados.orgao_emissor_rg" class="form-control" type="text">
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>UF do RG</label>
									<select v-model="dados.uf_rg" class="form-control">
												<option value="">Selecione o UF...</option>
												<option value="AC">AC</option>
												<option value="AL">AL</option>
												<option value="AM">AM</option>
												<option value="AP">AP</option>
												<option value="BA">BA</option>
												<option value="CE">CE</option>
												<option value="DF">DF</option>
												<option value="ES">ES</option>
												<option value="MA">MA</option>
												<option value="MG">MG</option>
												<option value="MS">MS</option>
												<option value="MT">MT</option>
												<option value="PA">PA</option>
												<option value="PB">PB</option>
												<option value="PE">PE</option>
												<option value="PI">PI</option>
												<option value="PR">PR</option>
												<option value="RJ">RJ</option>
												<option value="RN">RN</option>
												<option value="RO">RO</option>
												<option value="RR">RR</option>
												<option value="RS">RS</option>
												<option value="SC">SC</option>
												<option value="SE">SE</option>
												<option value="SP">SP</option>
												<option value="TO">TO</option>
											</select>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Data de emissão do RG</label>
									<input v-model="dados.data_emissao_rg" class="form-control" type="date">
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Situação</label>
									<select v-validate="'required'" name="situacao" v-model="dados.situacao" class="form-control">
												<option :value="SITUACAO.ATIVA">Ativo</option>
												<option :value="SITUACAO.INATIVA">Inativo</option>
											</select>
									<span class="text-danger">{{ errors.first('situacao') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="box-footer">
						<div class="row">
							<div class="col-md-12">
								<button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
								<button class="btn btn-default pull-left" @click="$router.go(-1)"> <i class="fa fa-reply"></i> Voltar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http
	import {
		mask
	} from "vue-the-mask";
	import {
		SEXO,
		SITUACAO
	} from "@/constants";

	export default {
		directives: {
			mask
		},
		inject: ["$validator"],
		computed: {
			SEXO: function() {
				return SEXO;
			},
			SITUACAO: function() {
				return SITUACAO;
			}
		},
		data: () => ({
			dados: {
				nome: "",
				conselho: "CRM",
				registro_conselho: '',
				situacao: 1,
				cns: "",
				email: "",
				data_admissao: "",
				data_desligamento: "",
				data_nascimento: "",
				sexo: 1,
				rg: "",
				orgao_emissor_rg: "",
				uf_rg: "",
				data_emissao_rg: "",
				cpf: "",
				telefone: "",
				profissionais: "",
				hora_final: ""
			},
			profissionalId: "",
			boxTitle: "Novo Profissional"
		}),
		mounted() {
			this.profissionalId = this.$route.params.profissionalId;
			if (this.profissionalId) {
				this.boxTitle = "Editar Profissional";
				this.getProfissional(this.profissionalId);
			}
		},
		methods: {
			getProfissional(profissionalId) {
				axios
					.get(
						`${this.$store.state.serverURI}/api/cadastros/profissionais/getById/${this.profissionalId}`,
						this.$store.getters.getHeaderAuth
					)
					.then(response => {
						this.dados = response.data;
					})
					.catch(error => {
						console.log(error);
					});
			},
			salvar() {
				this.$validator.validate().then(result => {
					if (result) {
						if (this.profissionalId) {
							axios
								.post(
									`${this.$store.state.serverURI
								}/api/cadastros/profissionais/update/${this.profissionalId}`,
									this.dados,
									this.$store.getters.getHeaderAuth
								)
								.then(response => {
									this.$swal({
										type: "success",
										title: "Profissional atualizado com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push("/cadastros/profissionais/");
								})
								.catch(error => {
									var erros = error.response.data.message + " ";
									for (var erro of Object.values(error.response.data.errors)) {
										erros += erro + " \n";
									}
									this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
						} else {
							axios
								.post(
									`${this.$store.state.serverURI}/api/cadastros/profissionais/create`,
									this.dados,
									this.$store.getters.getHeaderAuth
								)
								.then(response => {
									this.$swal({
										type: "success",
										title: "Profissional criado com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push("/cadastros/profissionais");
								})
								.catch(error => {
									var erros = error.response.data.message + " ";
									for (var erro of Object.values(error.response.data.errors)) {
										erros += erro + " \n";
									}
									this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
						}

					}
				});
			}
		},
		watch: {},
		components: {}
	};
</script>

<style>

</style>



// WEBPACK FOOTER //
// form.vue?2b760fd6